// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"325":"6041cb45","557":"43e648bd","639":"8973e7af","666":"2f684a94","873":"98d1fd2c"}[chunkId] + ".chunk.css";
};